// extracted by mini-css-extract-plugin
export default {"companyContainer":"lP-z","companyImage":"mP-z","container":"nP-z","heading":"oP-z","darkText":"pP-z","smallHeading":"qP-z","darkBackground":"rP-z","whiteBackground":"sP-z"};